import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { MgAreaSelect } from '../form-items';
import { useFormItemRender } from '@/share/components/xeui/use';
import { computed } from 'vue';

import { inject } from 'vue';
export default {
  __name: 'mg-area-select',
  props: {
    renderOpts: {
      type: Object,
      default: () => ({})
    },
    renderParams: {
      type: Object,
      default: () => ({})
    }
  },
  setup(__props) {
    const $xeForm = inject('$xeForm');
    const props = __props;
    const disabled = computed(() => {
      const {
        disabled = false
      } = props.renderParams;
      return disabled;
    });
    const readonly = computed(() => {
      const {
        readonly = false
      } = props.renderParams;
      return readonly;
    });
    const fields = computed(() => {
      const {
        props: fieldProps = {}
      } = props.renderOpts || {};
      const {
        fields = {}
      } = fieldProps || {};
      return fields;
    });
    const provinceField = computed(() => {
      const {
        province = ''
      } = fields.value || {};
      return province;
    });
    const cityField = computed(() => {
      const {
        city = ''
      } = fields.value || {};
      return city;
    });
    const countyField = computed(() => {
      const {
        county = ''
      } = fields.value || {};
      return county;
    });
    const {
      formData,
      fieldName,
      fieldOptions
    } = useFormItemRender(props);
    const fieldIsVisible = computed(() => {
      return formData && (fieldName || provinceField || cityField || countyField);
    });
    const handleProvinceChanged = val => {
      if (provinceField && $xeForm) {
        $xeForm.clearValidate(provinceField);
      } else if (fieldName && $xeForm) {
        $xeForm.clearValidate(fieldName);
      }
    };
    const handleCityChanged = val => {
      if (cityField && $xeForm) {
        $xeForm.clearValidate(cityField);
      } else if (fieldName && $xeForm) {
        $xeForm.clearValidate(fieldName);
      }
    };
    const handleCountyChanged = val => {
      if (countyField && $xeForm) {
        $xeForm.clearValidate(countyField);
      } else if (fieldName && $xeForm) {
        $xeForm.clearValidate(fieldName);
      }
    };
    const handleModelValueChanged = () => {
      if (fieldName && $xeForm) {
        $xeForm.clearValidate(fieldName);
      }
    };
    return (_ctx, _cache) => {
      return fieldIsVisible.value && provinceField.value && cityField.value && countyField.value ? (_openBlock(), _createBlock(_unref(MgAreaSelect), _mergeProps({
        key: 0
      }, _unref(fieldOptions), {
        disabled: disabled.value,
        readonly: readonly.value,
        "province-id": _unref(formData)[provinceField.value],
        "onUpdate:provinceId": [_cache[0] || (_cache[0] = $event => _unref(formData)[provinceField.value] = $event), handleProvinceChanged],
        "city-id": _unref(formData)[cityField.value],
        "onUpdate:cityId": [_cache[1] || (_cache[1] = $event => _unref(formData)[cityField.value] = $event), handleCityChanged],
        "county-id": _unref(formData)[countyField.value],
        "onUpdate:countyId": [_cache[2] || (_cache[2] = $event => _unref(formData)[countyField.value] = $event), handleCountyChanged]
      }), null, 16, ["disabled", "readonly", "province-id", "city-id", "county-id"])) : fieldIsVisible.value && provinceField.value && cityField.value && !countyField.value ? (_openBlock(), _createBlock(_unref(MgAreaSelect), _mergeProps({
        key: 1
      }, _unref(fieldOptions), {
        disabled: disabled.value,
        readonly: readonly.value,
        "province-id": _unref(formData)[provinceField.value],
        "onUpdate:provinceId": [_cache[3] || (_cache[3] = $event => _unref(formData)[provinceField.value] = $event), handleProvinceChanged],
        "city-id": _unref(formData)[cityField.value],
        "onUpdate:cityId": [_cache[4] || (_cache[4] = $event => _unref(formData)[cityField.value] = $event), handleCityChanged],
        "show-county": false
      }), null, 16, ["disabled", "readonly", "province-id", "city-id"])) : fieldIsVisible.value && provinceField.value && !cityField.value && !countyField.value ? (_openBlock(), _createBlock(_unref(MgAreaSelect), _mergeProps({
        key: 2
      }, _unref(fieldOptions), {
        disabled: disabled.value,
        readonly: readonly.value,
        "province-id": _unref(formData)[provinceField.value],
        "onUpdate:provinceId": _cache[5] || (_cache[5] = $event => _unref(formData)[provinceField.value] = $event),
        "show-county": false,
        "show-city": false,
        "onUpdate:modelValue": handleModelValueChanged
      }), null, 16, ["disabled", "readonly", "province-id"])) : fieldIsVisible.value && _unref(fieldName) ? (_openBlock(), _createBlock(_unref(MgAreaSelect), _mergeProps({
        key: 3
      }, _unref(fieldOptions), {
        disabled: disabled.value,
        readonly: readonly.value,
        modelValue: _unref(formData)[_unref(fieldName)],
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(formData)[_unref(fieldName)] = $event)
      }), null, 16, ["disabled", "readonly", "modelValue"])) : _createCommentVNode("", true);
    };
  }
};